import { ContentPageContainer, ContentPageTitle } from '@presentation/components';
import type { FC } from 'react';
import * as Styled from './styled';
import type { LitterLinksPageProps } from './types';

export * from './types';

export const LitterLinksPage: FC<LitterLinksPageProps> = (props) => {
  const { items, pageTitle } = props;

  return (
    <ContentPageContainer>
      <ContentPageTitle>{pageTitle}</ContentPageTitle>
      <Styled.Section>
        <Styled.LinksContainer>
          {items.map((link, linkKey) => (
            <Styled.StyledLink key={linkKey} to={link.to}>
              {link.label}
            </Styled.StyledLink>
          ))}
        </Styled.LinksContainer>
      </Styled.Section>
    </ContentPageContainer>
  );
};
